export default "__VITE_ASSET__Ch$MPvT1__"